import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import PrimaryButtonComponent from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';

const QuizButton = ({ id }) => {
  const navigate = useNavigate();
  return (
    <PrimaryButtonComponent
      functionName={(e) => {
        e.preventDefault();
        navigate(`/course/quiz/${id}`);
      }}
      span="Take Quiz"
    />
  );
};
QuizButton.propTypes = {
  id: PropTypes.string.isRequired,
};

export default QuizButton;
